export const Views = {
  DataPrivacy: 'data-privacy',
  ComplianceRequestChange: 'compliance-request-change',
  ComplianceRequestCopy: 'compliance-request-copy',
  ComplianceRequestDelete: 'data-compliance-request-delete',
  ComplianceRequestVerify: 'compliance-request-verify',
  ComplianceRequestDoNotSell: 'data-compliance-request-do-not-sell',
  PrivacyOptionsSelector: 'privacy-options-selector',
  ConsentManagement: 'consent-management',
  ConsentCategoryDetail: 'consent-category-detail',
};

export type ViewKeys = keyof typeof Views;
export type ViewValues = (typeof Views)[ViewKeys];
